<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">续订代码</span></div>
		<div class="margin-top margin-left margin-right">
			<div style="display: flex;">
				<select v-model="status" style="width: 140px; margin-right: 10px;" @change="doSearch">
					<option value="">全部状态</option>
					<option value="0">未使用</option>
					<option value="1">已使用</option>
				</select>
				<input type="text" v-model="batchNo" placeholder="输入批次号搜索" style="width: 200px;"
					   @keyup.enter="doSearch"/>
				<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
				<div style="margin-left: auto;">
					<Button @click="exportCsv">导出当前页</Button>
					<Button @click="exportAll">导出全部</Button>
					<Button color="primary" icon="fa fa-plus" @click="openGenerate">批量生成</Button>
				</div>
			</div>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="code" title="激活码" :width="200"/>
				<TableItem prop="type" title="类型" :width="100"/>
				<TableItem prop="days" title="天数" :width="80" align="center"/>
				<TableItem title="状态" :width="90" align="center">
					<template slot-scope="{data}">
						<span :class="data.status === 1 ? 'green-color' : 'gray-color'">
							{{ data.status === 1 ? '已使用' : '未使用' }}
						</span>
					</template>
				</TableItem>
				<TableItem prop="batchNo" title="批次号" :width="140"/>
				<TableItem title="使用时间" :width="150">
					<template slot-scope="{data}">
						{{ datetimeFormat(data.usedDate) }}
					</template>
				</TableItem>
				<TableItem title="创建时间" :width="150">
					<template slot-scope="{data}">
						{{ datetimeFormat(data.createDate) }}
					</template>
				</TableItem>
				<TableItem title="操作" :width="90" align="center">
					<div class="actions" slot-scope="{data}">
						<span v-if="data.status !== 1" @click="remove(data)">作废</span>
					</div>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>

		<Modal v-model="showGenerate" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">批量生成续订代码</div>
			<Form :labelWidth="90" ref="form" :rules="validationRules" :model="form">
				<FormItem label="类型" prop="type">
					<select v-model="form.type" @change="onTypeChange">
						<option value="月卡">月卡（30天）</option>
						<option value="季卡">季卡（90天）</option>
						<option value="年卡">年卡（365天）</option>
						<option value="自定义">自定义</option>
					</select>
				</FormItem>
				<FormItem label="天数" prop="days">
					<input type="number" v-model.number="form.days" min="1" max="3650"/>
				</FormItem>
				<FormItem label="生成数量" prop="count">
					<input type="number" v-model.number="form.count" min="1" max="500"/>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showGenerate=false">取消</Button>
				<Button color="primary" :loading="saving" @click="generate">生成</Button>
			</div>
		</Modal>

			<Modal v-model="showNewCodes" hasCloseIcon hasDivider :closeOnMask="false">
				<div slot="header">生成成功（明文仅此一次展示，请立即保存）</div>
				<div class="red-color" style="margin-bottom: 10px;">激活码已加密存储，关闭后将无法再次查看明文！</div>
				<div style="max-height: 320px; overflow-y: auto; font-family: monospace; line-height: 1.9;">
					<div v-for="code in newCodes" :key="code">{{ code }}</div>
				</div>
				<div slot="footer">
					<Button color="primary" @click="copyNewCodes">复制全部</Button>
					<Button @click="showNewCodes=false">我已保存，关闭</Button>
				</div>
			</Modal>
		</app-content>
	</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminRenewalCodes",
		data() {
			return {
				loading: false,
				saving: false,
				showGenerate: false,
				showNewCodes: false,
				newCodes: [],
				status: '',
				batchNo: '',
				dataList: [],
				pagination: {page: 1, size: 20, total: 0},
				form: {},
				validationRules: {
					required: ['type', 'days', 'count']
				}
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.admin.renewalCodes({
					page: this.pagination.page,
					size: this.pagination.size,
					status: this.status === '' ? undefined : this.status,
					batchNo: this.batchNo || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			openGenerate() {
				this.form = {type: '月卡', days: 30, count: 10};
				this.showGenerate = true;
			},
			onTypeChange() {
				let daysMap = {'月卡': 30, '季卡': 90, '年卡': 365};
				if (daysMap[this.form.type]) {
					this.form.days = daysMap[this.form.type];
				}
			},
			generate() {
				if (!this.$refs.form.valid().result) {
					return;
				}
				this.saving = true;
				this.$api.admin.generateRenewalCodes(this.form).then(({data}) => {
					this.showGenerate = false;
					this.loadList();
					//明文激活码仅此一次返回，需立即复制保存
					if (data.codes && data.codes.length) {
						this.newCodes = data.codes;
						this.showNewCodes = true;
					} else {
						this.$Message.success(`已生成 ${data.count} 个激活码，批次号：${data.batchNo}`);
					}
				}).finally(() => this.saving = false);
			},
			copyNewCodes() {
				let text = this.newCodes.join('\n');
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(text).then(() => this.$Message.success('已复制全部激活码'));
				} else {
					let ta = document.createElement('textarea');
					ta.value = text;
					document.body.appendChild(ta);
					ta.select();
					document.execCommand('copy');
					document.body.removeChild(ta);
					this.$Message.success('已复制全部激活码');
				}
			},
			remove(data) {
				this.$Confirm(`确认作废激活码【${data.code}】?`).then(() => {
					this.$api.admin.deleteRenewalCode({id: data.id}).then(() => {
						this.$Message.success('作废成功~');
						this.loadList();
					});
				});
			},
			csvSafe(v) {
				if (v == null) return '';
				let s = String(v).replace(/"/g, '""');
				if (/[",\n\r=+\-@]/.test(s)) {
					s = '"' + s + '"';
				}
				if (s.length > 0 && '=+-@'.indexOf(s.charAt(0)) >= 0) {
					s = "'" + s;
				}
				return s;
			},
			exportCsv() {
				let rows = [['激活码', '类型', '天数', '状态', '批次号', '使用时间']];
				this.dataList.forEach(item => {
					rows.push([
						this.csvSafe(item.code), this.csvSafe(item.type), this.csvSafe(item.days),
						this.csvSafe(item.status === 1 ? '已使用' : '未使用'),
						this.csvSafe(item.batchNo),
						this.csvSafe(item.usedDate ? moment(item.usedDate).format('YYYY-MM-DD HH:mm') : '')
					]);
				});
				let csv = '\uFEFF' + rows.map(r => r.join(',')).join('\n');
				let link = document.createElement('a');
				link.href = URL.createObjectURL(new Blob([csv], {type: 'text/csv'}));
				link.download = `续订代码_${moment().format('YYYYMMDDHHmmss')}.csv`;
				link.click();
			},
			exportAll() {
				//服务端全量导出，跟随当前筛选条件
				window.open(this.$api.admin.renewalExportUrl({
					status: this.status === '' ? undefined : this.status,
					batchNo: this.batchNo || undefined
				}));
			},
			datetimeFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD HH:mm') : '';
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>
